var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9248 6.85384C15.1422 3.41023 12.1383 1.85986 9.49973 1.85986C9.49973 1.85986 9.49973 1.85986 9.49228 1.85986C6.86112 1.85986 3.84982 3.40278 3.06719 6.84639C2.1951 10.6925 4.55047 13.9498 6.68223 15.9995C7.47232 16.7598 8.48603 17.14 9.49973 17.14C10.5134 17.14 11.5271 16.7598 12.3098 15.9995C14.4415 13.9498 16.7969 10.7 15.9248 6.85384ZM9.49973 10.5881C8.20279 10.5881 7.15182 9.53718 7.15182 8.24023C7.15182 6.94329 8.20279 5.89232 9.49973 5.89232C10.7967 5.89232 11.8476 6.94329 11.8476 8.24023C11.8476 9.53718 10.7967 10.5881 9.49973 10.5881Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7ad1cd8255f933ce7d7ddc563d38159d.svg";
export { ForwardRef as ReactComponent };